module.exports = __webpack_public_path__ + "static/img/VARESE-SILKEN-MAPLE.0879c21.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VARESE-SILKEN-MAPLE.png
// module id = 0c2k
// module chunks = 0